import { Button, ArrowForwardIcon } from '@methanesat/ui-components';
import { useTranslate } from '../../../../../hooks';

export const OGIMoreInfoButton = ({ onClick, disabled }: { onClick: () => void; disabled: boolean }) => {
    const t = useTranslate();
    return (
        <Button
            data-testid="ogi-more-info-button"
            variant="outlined"
            color="info"
            onClick={onClick}
            endIcon={<ArrowForwardIcon />}
            disabled={disabled}
        >
            {t('emissionsMapPage.infrastructure.ogiNearEmissions.nearbyFacilitiesPrompt')}
        </Button>
    );
};
